import API from './API'
import Record_behavir from './FirebaseAPI/RecordBill'
import Cookies from 'js-cookie'

var record = new Record_behavir()

var CustomerizeService = (function () {
  function customerize() {}
  customerize.prototype.update = async function (payload) {
    return await API.put('customerize/update', payload)
      .then((data) => {
        if (!data.success) throw new RangeError(data.result)
        let recordInfo = {}
        recordInfo.type = '客製化服務'
        recordInfo.event = '更新服務'
        recordInfo.code = Cookies.get('GladTeamCode')
        recordInfo.id = payload.id
        recordInfo.note = payload.name
        recordInfo.user_name = Cookies.get('GladName')
        recordInfo.user_id = ''
        record.postRecord(recordInfo)
        return {
          success: true,
          message: data,
        }
      })
      .catch((err) => {
        return {
          success: false,
          message: err,
        }
      })
  }
  customerize.prototype.delete = async function (payload) {
    return await API.put('customerize/delete', payload)
      .then((data) => {
        if (!data.success) throw new RangeError(data.result)
        let recordInfo = {}
        recordInfo.type = '客製化服務'
        recordInfo.event = '刪除服務'
        recordInfo.code = Cookies.get('GladTeamCode')
        recordInfo.id = payload.id
        recordInfo.note = name
        recordInfo.user_name = Cookies.get('GladName')
        recordInfo.user_id = ''
        record.postRecord(recordInfo)
        return {
          success: true,
          message: data,
        }
      })
      .catch((err) => {
        return {
          success: false,
          message: err,
        }
      })
  }
  customerize.prototype.create = async function (payload) {
    return await API.post('customerize/create', payload)
      .then((data) => {
        if (!data.success) throw new RangeError(data.result)
        let recordInfo = {}
        recordInfo.type = '客製化服務'
        recordInfo.event = '新增服務'
        recordInfo.code = Cookies.get('GladTeamCode')
        recordInfo.id = ''
        recordInfo.note = payload.name
        recordInfo.user_name = Cookies.get('GladName')
        recordInfo.user_id = ''
        record.postRecord(recordInfo)
        return {
          success: true,
          message: data,
        }
      })
      .catch((err) => {
        return {
          success: false,
          message: err,
        }
      })
  }

  return customerize
})()
export default CustomerizeService



// WEBPACK FOOTER //
// ./src/assets/js/libs/CustomerizeService.js